<template>
  <div class="d-flex flex-column content-placeholder"></div>
</template>

<script>
export default {
  name: "Placeholder",
};
</script>

<style scoped>
.content-placeholder {
  background: #eeeeee;
  border-radius: 0.85rem;
  position: relative;
  overflow: hidden;
}

.content-placeholder:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100px;
  background: linear-gradient(90deg, #eeeeee, #f4f4f4, #eeeeee);
  animation: content-placeholder-gradient 1s infinite ease-in-out;
}

@keyframes content-placeholder-gradient {
  from {
    left: 0;
  }
  to {
    left: 100%;
  }
}
</style>
